import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCustomer } from '../contexts/CustomerContext';

/**
 * Hook to automatically redirect to admin dashboard when impersonation ends
 * This handles cases where impersonation ends due to session timeout, 
 * manual exit, or other reasons
 */
const useImpersonationRedirect = () => {
  const navigate = useNavigate();
  const { setAutoRedirect } = useCustomer();

  useEffect(() => {
    // Set up auto-redirect to admin dashboard when impersonation ends
    setAutoRedirect(() => {
      // console.log('Auto-redirecting to admin dashboard due to impersonation end');
      navigate('/app/admin-dashboard', { replace: true });
    });
  }, [navigate, setAutoRedirect]);
};

export default useImpersonationRedirect;
